/* Inject Hubspot Banner into resources */
var CTAFlag = false;
var entryContent = false;
document.addEventListener('DOMContentLoaded', function () {
 
	var bodyClass = document.querySelectorAll(".single-post");

	if (bodyClass[0]) {
		var entryContent = bodyClass[0].querySelectorAll(".entry-content");
	
		
		bannerHtml = `<!--HubSpot Call-to-Action Code -->
								<span class="hs-cta-wrapper" id="hs-cta-wrapper-07c7e9f4-db31-489b-a895-d7268907905c">
										<span class="hs-cta-node hs-cta-07c7e9f4-db31-489b-a895-d7268907905c" id="hs-cta-07c7e9f4-db31-489b-a895-d7268907905c">
												<!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
												<a href="https://cta-redirect.hubspot.com/cta/redirect/6216338/07c7e9f4-db31-489b-a895-d7268907905c" target="_blank" rel="noopener">
														<img class="hs-cta-img" id="hs-cta-img-07c7e9f4-db31-489b-a895-d7268907905c" style="border-width:0px;" src="https://no-cache.hubspot.com/cta/default/6216338/07c7e9f4-db31-489b-a895-d7268907905c.png" alt="New call-to-action"/>
												</a>
										</span>
								</span>
								<!-- end HubSpot Call-to-Action Code -->`;

		if (entryContent.length && !CTAFlag) {

			var headings = entryContent[0].querySelectorAll('h1, h2, h3, h4, h5, h6');
			var numHeadings = headings.length;
			if (numHeadings >= 3) {
				var selectedHeading = headings[numHeadings-2];
				var newElement = document.createElement('div');
				newElement.innerHTML = bannerHtml;
				selectedHeading.parentNode.insertBefore(newElement, selectedHeading);
			} else if (numHeadings == 2) {
				var selectedHeading = headings[numHeadings-1];
				var newElement = document.createElement('div');
				newElement.innerHTML = bannerHtml;
				selectedHeading.parentNode.insertBefore(newElement, selectedHeading);
			} else {
				entryContent[0].innerHTML = entryContent[0].innerHTML + bannerHtml;
			}

			$.getScript('https://js.hscta.net/cta/current.js', () => {
		      	if (!CTAFlag) {
			    	CTAFlag = true;
					window.hbspt.cta.load(6216338, '07c7e9f4-db31-489b-a895-d7268907905c', {"useNewLoader":"true","region":"na1"}); 
			    	console.log('hbspt.cta.load');
				}
		    });
		  	
		}
	}
});
